import React from 'react'

import cx from 'classnames'

import styles from './styles.module.css'

interface Props {
  online: boolean
  warning?: boolean
  className?: string
}

export const OnlineIndicator: React.FC<Props> = ({ online, warning, className }) => {
  return (
    <div
      className={cx(styles.onlineIndicator, className, {
        [styles.online]: online,
        [styles.warning]: warning
      })}
    />
  )
}

export const OnlineIndicatorWithBorder: React.FC<Props> = ({ online, className }) => {
  return (
    <div className={styles.indicatorBorder}>
      <OnlineIndicator online={online} className={className} />
    </div>
  )
}

export default OnlineIndicator
